import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionStaff } from './competition-staff'
import { CompetitionStaffSerializer } from './competition-staff.serializer'

@Injectable()
export class CompetitionStaffService extends ResourceService<CompetitionStaff> {
  constructor(
    private http: HttpClient,
    private competitionStaffSerializer: CompetitionStaffSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-staff`,
      competitionStaffSerializer
    )
  }
}
